module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('link', {
    attrs: {
      "href": "styles/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('title', [_vm._v("Aunt Bee’s Delightful Desserts: More Than 350 Recipes from Mayberry, Americas’s Friendliest Town")]), _vm._v(" "), _c('p', {
    staticClass: "ctc",
    attrs: {
      "id": "pz7-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contents#RR_03",
      "id": "CC_03"
    }
  }, [_c('i', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "pz7-2"
    }
  }, [_vm._v("First and foremost, we salute the actors, writers, and production crew who worked on "), _c('i', [_vm._v("The Andy Griffith Show")]), _vm._v(" and built the place called Mayberry that has been enjoyed and loved by generations—a place that continues to warm our hearts today. Without the fruits of their talents and efforts, we wouldn’t be able to offer pies or any of the other treats that have that very special flavor of Mayberry. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz7-3"
    }
  }, [_vm._v("Many of those same people have shared recipes for this book and allowed us to use photographs that capture their Mayberry roles—all of which has helped this book be an even more meaningful tribute to Mayberry. We’re most grateful for their participation. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz7-4"
    }
  }, [_vm._v("We also thank everyone across the country who provided us with their favorite recipes. Recipes are the heart of any cookbook. (And we have the stomachs to prove it!) Attribution for each contributor accompanies the recipes, and we extend our heartfelt and stomachfelt gratitude to you all. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz7-5"
    }
  }, [_vm._v("We likewise appreciate the assistance of several friends who helped us round up recipes from other folks. They are Kenneth Junkin, Neal Brower, David Fernandes, Dale Robinson, Nancy Clark, Harriet Patterson, Rebecca Barnes, John Faulkner, Katherine Clark, Albert Culbreath, Jim Ballance, John Lock, Randy Bash, Sherwin Bash, Carolyn Moore, Jon Snyder, Joel Rasmussen, Gary Cannon, Bruce Fisher, Alex Mebane, Janice Starnes, Ren Hood, Burt Phifer, Jan McNees, Peggy Myres, and Roland White. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz7-6"
    }
  }, [_vm._v("In addition, we thank folks who made contributions beyond the recipes themselves. For assistance with photographs, we thank "), _c('i', [_vm._v("The Tennessean")]), _vm._v(" and Frank Sutherland; David Turner and Mitch Powers at Small World Productions; Dennis Hasty; Jackie Joseph; Arlene Golonka; Bob Wagner; Don Pitts; and Albert Cooper. For invaluable help both with photographs and in rounding up recipes, we give particular recognition to Jim Schwenke and Steve Cox. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz7-7"
    }
  }, [_vm._v("We have special thanks for producer Aaron Ruben for introducing us to the tremendous work done by the National Court Appointed Special Advocate Association (CASA), and to Mercedes Lawry at National CASA for providing further information about the organization’s efforts. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz7-8"
    }
  }, [_vm._v("Our primary expertise with food is eating. As Goober once summed up our sentiments, “Three hours is a long time to go without eating.” Ken has always cleaned his plate and saved room for dessert when eating the cooking of Grandma Beck, Grandma Rogers, and Hazel (Mama) Beck, and today he shares wife Wendy’s good desserts with daughter Kylie and son Cole. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz7-9"
    }
  }, [_vm._v("The clock in Jim’s stomach first began ticking while eating desserts from the kitchen of Tonya (Gramma) Hamel and Nancy (Mom) Clark. And you’d better watch out for his hearty eatin’ around wife Mary’s cooking. Even after he’s given battered beaters a licking, his stomach keeps on ticking. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz7-10"
    }
  }, [_vm._v("Finally, we thank Viacom for entrusting this cookbook with us, and Larry Stone at Thomas Nelson for again believing in Mayberry and this project. Editor Amy Lyles Wilson, recipe editor Laurin Stamm, Charla Honea, Mike Towle, Jennifer B. Green-stein, Bryan Curtis, Kath Hansen, Kirsten Hansen, and many other fine folks at Thomas Nelson all helped this Mayberry dream become a reality. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz7-11"
    }
  }, [_vm._v("Thank you all for your help. We appreciate it! ")]), _vm._v(" "), _c('p', {
    staticClass: "txr",
    attrs: {
      "id": "pz7-12"
    }
  }, [_vm._v("—Ken Beck and Jim Clark ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b746990c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter03.vue
// module id = 72
// module chunks = 0